import { put, call, takeLatest, all, select } from "redux-saga/effects";
import * as Pricing from "../api/pricingApi";
import { proxyInfo } from "../api/epicApi";//, getEvisitEligibility, getZipnosisEvisitUrl
import * as types from "../constants/actionTypes";
import { logAPI, logUI } from "../api/andyliticsApi";
import * as tools from '../helpers/Tools';


const getMRN = (currentUser) => {
    //const { patient, proxySubjects } = epic;
    let amrn = null;
    /*if (currentUser.eid !== patient.EID) {
        for (let i = 0; i < proxySubjects.length; i++) {
            const prxy = proxySubjects[i];
            if (prxy.patient.EID === currentUser.eid) {
                amrn = prxy.patient.AMRN;
            }
        }
    } else {
        amrn = patient.AMRN;
    }*/
    amrn = currentUser.AMRN;
    return amrn;
}

export default function* pricingSaga() {
    yield takeLatest(types.PRICING_USERSQUOTE_BENEFITDETAILS, handleGetBenefitDetails);
    yield takeLatest(types.PRICING_USERSQUOTE_APPOINTMENTS, handleGetAppointments);
    yield takeLatest(types.PRICING_USERSQUOTE_QUOTE_CLEAR, clearPricing);
    yield takeLatest(types.PRICING_USERSQUOTE_ESTIMATE_PDF, handleEstimateDownLoadURL);
    yield takeLatest(types.ESTIMATE_DETAILS_TILE_MESSAGE_DETAILS, toggleShowMessageDetails);
}

function* clearPricing() {
    try {
        yield put({ type: types.PRICING_USERSQUOTE_QUOTE_CLEAR_SUCCESS });
    } catch (e) {
        logAPI("MBHWeb.Saga.Pricing.clearPricing.Failure", new Date(), null, e);
    }
}

function* toggleShowMessageDetails(data) {
    const start = new Date();
    const isShown = !data.data.show;
    try {
        yield put({ type: types.ESTIMATE_DETAILS_TILE_MESSAGE_DETAILS_SUCCESS, isShown });
    } catch (e) {
        logAPI("MBHWeb.Saga.Pricing.toggleShowMessageDetails.Failure", start, null, e);
    }
}
//header.membershipData.epic.patient.AMRN
//header.membershipData.epic.patient.proxySubjects[].patient.AMRN
function* handleEstimateDownLoadURL(data) {
    const start = new Date();
    const token = data.data.token;
    const { currentUser } = data.data;
    const csnId = data.data.csnId;
    const patientId = getMRN(currentUser);
    const url = tools.buildUrl(window.serverData.data.pricingAPIURL, `/UsersQuote/EstimateCopyPDF?patientId=${patientId}&csnId=${csnId}`);
    try {
        if (patientId) {
            const pdf = yield call(Pricing.downLoadEstimate, token, url);
            yield put({ type: types.PRICING_USERSQUOTE_ESTIMATE_PDF_SUCCESS, pdf });
            logAPI("MBHWeb.Saga.Pricing.handleEstimateDownLoadURL", start, null, null, "pdf download");
        }
    } catch (e) {
        logAPI("MBHWeb.Saga.Pricing.handleEstimateDownLoadURL.Failure", start, null, e);
    }
}
//header.membershipData.epic.patient.AMRN
//header.membershipData.epic.patient.proxySubjects[].patient.AMRN
function* handleGetBenefitDetails(data) {
    const start = new Date();
    try {
        //const token = data.data.token;
        const userDetails = yield select((state) => state.sso.userDetails);
        const { currentUser} = data.data;
        const { access_token } = userDetails;
        const csnId = data.data.csnIdOfAppointment;
        const amrn = getMRN( currentUser);

        if (amrn) {
            yield put({ type: types.PRICING_USERQUOTE_APPOINTMENTS_LOADING });
            logAPI("MBHWeb.Saga.Pricing.GetBenefitDetails", start, null,null,null,"Call Api");
            const ben = yield call(Pricing.getBenefitDetails, access_token, amrn, csnId);
            logAPI("MBHWeb.Saga.Pricing.GetBenefitDetails", start, `estimateDetails/${csnId}`, ben, "Page View", "Finish Api");
            logUI("MBHWeb.Saga.Pricing.estimateDetails", start, `estimateDetails/${csnId}`,ben,"Page View",csnId);
            yield put({ type: types.PRICING_USERSQUOTE_BENEFITDETAILS_SUCCESS, ben });
        }

    }
    catch (error) {
        logAPI("MBHWeb.Saga.Pricing.GetBenefitDetails.Failure", start, null,error);
        yield all([
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}



function* handleGetAppointments(data) {
    //retry = retry ? retry : 'yes';
    const start = new Date();
    try {
        yield put({ type: types.PRICING_USERQUOTE_APPOINTMENTS_LOADING });
        const { currentUser } = data.data;
        const order = data.data.order ? data.data.order : "desc";
        const userDetails = yield select((state) => state.sso.userDetails);
        const { access_token } = userDetails;
        const amrn = getMRN(currentUser);

        if (amrn) {
            yield put({ type: types.PRICING_USERQUOTE_APPOINTMENTS_LOADING });
            let apts = [];
            const response = yield call(Pricing.getAppointments, access_token, amrn, false);
            if (response.statusText && response.statusText.toLowerCase() === "bad request") {
                console.error(`pricingSaga handleGetAppointments bad request`, response);
            } else if (response.status && response.status >= 300) { 
                console.error(`pricingSaga handleGetAppointments server error`, response);
            } else {
                apts = response;                   
            }
            if (!Array.isArray(apts)) {//if something causes apts to get here and it is not an array then it does not matter
                apts = [];
            }
            if (order === "desc") {
                apts.sort((a, b) => { return (new Date(b.dateOfService)) - (new Date(a.dateOfService)); });
            } else {
                apts.sort((a, b) => { return (new Date(a.dateOfService)) - (new Date(b.dateOfService)); });
            }
            yield put({ type: types.PRICING_USERSQUOTE_APPOINTMENTS_SUCCESS, apts });
            
        }
    } catch (error) {

            console.error(`pricingSaga handleGetAppointments error`, error, data);
            logAPI("MBHWeb.Saga.Pricing.GetAppointments.Failure", start, null);
            yield all([
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);

    }
}





